<app-header
    (back)="onBack()"
    [customBackText]="'GLOBAL.EXIT'"
    [customBackNavigation]="true"
    [canNavigateBack]="true"
    [showLanguage]="true"
    [redBorder]="true">
</app-header>
<div class="machines page d-flex flex-column justify-content-between" *ngIf="!loading">
    <app-carousel
        [items]="items"
        [hasGroup]="hasGroup"
        [setCurrentSlideItem]="setCurrentSlideItem"
        (next)="onNext()" >
    </app-carousel>
    <hr />
    <!-- <app-list
        *ngIf="cartEmpty"
        [title]="'RENT.BUNDLES.LIST_TITLE'"
        [items]="bundles"
        [selectable]="true"
        (selected)="onSelectBundle($event)" >
    </app-list> -->
    <app-list
        *ngIf="cartEmpty && solutionList.length > 0"
        [title]="'RENT.RECOMMENDED.PRODUCTS'"
        [items]="solutionList"
        [selectable]="true"
        > </app-list>
    <app-list
        *ngIf="!cartEmpty"
        [autoScroll]="true"
        [title]="'RENT.CART.TITLE'"
        [items]="cartItems"
        [pluses]="true"
        [removable]="true"
        (remove)="onRemove($event)">
    </app-list>
    <!-- <app-progress-tracker [progress]="progress"></app-progress-tracker> -->
    <div class="contact d-flex justify-content-between">
      <!--     TODO (877) 343-0588 is correct but admin should be able to change it-->
      <!--     TODO 8774704111 = mrent is correct but admin should be able to change it-->
            <p>For assistance call: (877) 343-0588</p>
            <p>Kiosk JDE: {{kioskJde ? kioskJde : '/'}}</p>
      </div>
</div>

<div class="spinner-position" *ngIf="loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
